import store from '@/store'
export default [
  {
    path: '/positions',
    name: 'position',
    meta: { requiresAuth: true },
    component: () => import('@/pages/position/index.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('position/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/positions/:id',
    name: 'position-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/position/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('position/dataBeforeCreate')
      let response = await store.dispatch('position/find', to.params.id)
      let { position_level, parent, ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
